import { watch as _, nextTick as X, getCurrentScope as Y, onScopeDispose as A, ref as x, reactive as C, computed as b, unref as z } from "vue";
var I;
const D = typeof window < "u", B = (e) => typeof e == "string", E = () => {
};
D && ((I = window == null ? void 0 : window.navigator) != null && I.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function F(e) {
  return Y() ? (A(e), !0) : !1;
}
function ee(e, n, o) {
  const t = _(e, (...s) => (X(() => t()), n(...s)), o);
}
function S(e) {
  var n;
  const o = z(e);
  return (n = o == null ? void 0 : o.$el) != null ? n : o;
}
const T = D ? window : void 0;
function g(...e) {
  let n, o, t, s;
  if (B(e[0]) ? ([o, t, s] = e, n = T) : [n, o, t, s] = e, !n)
    return E;
  let i = E;
  const a = _(() => S(n), (u) => {
    i(), u && (u.addEventListener(o, t, s), i = () => {
      u.removeEventListener(o, t, s), i = E;
    });
  }, { immediate: !0, flush: "post" }), l = () => {
    a(), i();
  };
  return F(l), l;
}
const $ = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, j = "__vueuse_ssr_handlers__";
$[j] = $[j] || {};
var k = Object.getOwnPropertySymbols, K = Object.prototype.hasOwnProperty, M = Object.prototype.propertyIsEnumerable, q = (e, n) => {
  var o = {};
  for (var t in e)
    K.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && k)
    for (var t of k(e))
      n.indexOf(t) < 0 && M.call(e, t) && (o[t] = e[t]);
  return o;
};
function J(e, n, o = {}) {
  const t = o, { window: s = T } = t, i = q(t, ["window"]);
  let a;
  const l = s && "ResizeObserver" in s, u = () => {
    a && (a.disconnect(), a = void 0);
  }, v = _(() => S(e), (p) => {
    u(), l && s && p && (a = new ResizeObserver(n), a.observe(p, i));
  }, { immediate: !0, flush: "post" }), f = () => {
    u(), v();
  };
  return F(f), {
    isSupported: l,
    stop: f
  };
}
function te(e, n = { width: 0, height: 0 }, o = {}) {
  const t = x(n.width), s = x(n.height);
  return J(e, ([i]) => {
    t.value = i.contentRect.width, s.value = i.contentRect.height;
  }, o), _(() => S(e), (i) => {
    t.value = i ? n.width : 0, s.value = i ? n.height : 0;
  }), {
    width: t,
    height: s
  };
}
var h;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(h || (h = {}));
function ne(e, n = {}) {
  const {
    threshold: o = 50,
    onSwipe: t,
    onSwipeEnd: s,
    onSwipeStart: i,
    passive: a = !0,
    window: l = T
  } = n, u = C({ x: 0, y: 0 }), v = C({ x: 0, y: 0 }), f = b(() => u.x - v.x), p = b(() => u.y - v.y), { max: G, abs: y } = Math, P = b(() => G(y(f.value), y(p.value)) >= o), w = x(!1), N = b(() => P.value ? y(f.value) > y(p.value) ? f.value > 0 ? h.LEFT : h.RIGHT : p.value > 0 ? h.UP : h.DOWN : h.NONE), R = (r) => [r.touches[0].clientX, r.touches[0].clientY], H = (r, d) => {
    u.x = r, u.y = d;
  }, L = (r, d) => {
    v.x = r, v.y = d;
  };
  let c;
  const m = Q(l == null ? void 0 : l.document);
  a ? c = m ? { passive: !0 } : { capture: !1 } : c = m ? { passive: !1, capture: !0 } : { capture: !0 };
  const W = (r) => {
    w.value && (s == null || s(r, N.value)), w.value = !1;
  }, U = [
    g(e, "touchstart", (r) => {
      c.capture && !c.passive && r.preventDefault();
      const [d, O] = R(r);
      H(d, O), L(d, O), i == null || i(r);
    }, c),
    g(e, "touchmove", (r) => {
      const [d, O] = R(r);
      L(d, O), !w.value && P.value && (w.value = !0), w.value && (t == null || t(r));
    }, c),
    g(e, "touchend", W, c),
    g(e, "touchcancel", W, c)
  ];
  return {
    isPassiveEventSupported: m,
    isSwiping: w,
    direction: N,
    coordsStart: u,
    coordsEnd: v,
    lengthX: f,
    lengthY: p,
    stop: () => U.forEach((r) => r())
  };
}
function Q(e) {
  if (!e)
    return !1;
  let n = !1;
  const o = {
    get passive() {
      return n = !0, !1;
    }
  };
  return e.addEventListener("x", E, o), e.removeEventListener("x", E), n;
}
export {
  g as a,
  ne as b,
  te as u,
  ee as w
};
//# sourceMappingURL=index.AJuLibkw.js.map
